<template>
  <vx-card class="min-h-screen">
		<ResponseAlert ref="response" />
		<vs-table
			:sst="true"
			@sort="sort"
      :data="config.rows"
		>
			<template slot="header">
				<vs-row>
					<vs-col class="mt-5" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
						<vs-row
							class="mb-5"
							vs-align="flex-end"
							vs-type="flex" vs-justify="flex-end" vs-w="12">
							<vs-col class="mt-3 md:mt-0 ml-0 md:ml-3" vs-lg="3" vs-sm="4" vs-xs="12">
								<div class="relative">
									<i class="vs-icon notranslate icon-scale material-icons null absolute z-50" style="top: 12px; right: 10px">search</i>
									<vs-input class="w-full" placeholder="Search" v-model="config.search" @input="handleSearch"/>
								</div>
							</vs-col>
						</vs-row>
					</vs-col>
				</vs-row>
            </template>
			<template slot="thead">
				<vs-th :sort-key="row.value" v-for="(row, key) in config.headers" :key="key" :width="row.width" :class="row.class">
					{{row.title}}
				</vs-th>
			</template>
			<template slot-scope="{data}">
				<vs-tr :key="indextr" v-for="(tr, indextr) in data" >
					<vs-td :data="data[indextr].name">
						{{data[indextr].name}}
					</vs-td>
					<vs-td :data="data[indextr].community">
						{{data[indextr].community ? data[indextr].community.join(', ') : '-'}}
					</vs-td>

					<vs-td :data="data[indextr].followerIg">
						{{data[indextr].followerIg}}
					</vs-td>

					<vs-td :data="data[indextr].followerTiktok">
						{{data[indextr].followerTiktok}}
					</vs-td>

					<vs-td :data="data[indextr].province">
						{{data[indextr].province}}
					</vs-td>
                    <vs-td :data="data[indextr].suspendBy">
						{{data[indextr].suspendBy}}
					</vs-td>
                    <vs-td :data="data[indextr].suspendAt">
						{{data[indextr].suspendAt ? moment(data[indextr].suspendAt).format('DD MMMM YYYY') : "-"}}
					</vs-td>

                    <vs-td class="flex">
                        <router-link :to="`/${config.uri}/${data[indextr].id}`" class="text-black">
							<feather-icon icon="EyeIcon" svgClasses="w-5 h-5 mr-3 stroke-current cursor-pointer" />
						</router-link>
                        <!-- <a href="javascript:void(0)" @click="openApproveModal(data[indextr].id)" class="text-black">
                            <feather-icon icon="CheckIcon" svgClasses="w-5 h-5 mr-3 stroke-current cursor-pointer" />
                        </a> -->
                    </vs-td>
				</vs-tr>
			</template>
		</vs-table>

		<Pagination :config="config" @gotoPage="gotoPage"/>
        
	</vx-card>
</template>

<script>
import moment from 'moment'
import {getColorStatus} from '@/utils/helpers'
import api from '@/utils/api'
export default {
		name: 'ListRequestUnsuspend',
		data() {
			return {
				config: {
					uri: this.$route.meta.link,
					api: api.brandAmbasador + '/request-unsuspend',
                    //api: api.brandAmbasador,
					rows: [],
					total_data: 0,
					total_page: 0,
					per_page: 10,
					page: 1,
					orderby: "id",
					sort: "desc",
					search: "",
					debounce: null,
					headers: [{
						title: "Name",
						value: "name",
						align: "text-left",
						width: "20%",
					},{
						title: "Community",
						value: "community",
						align: "text-left",
						width: "15%",
					}, {
						title: "Instagram",
						value: "followerIg",
						align: "text-left",
						width: "10%",
					}, {
						title: "Tiktok",
						value: "followerTiktok",
						align: "text-left",
						width: "10%",
					}, {
						title: "City/Domicile",
						value: "province",
						align: "text-left",
						width: "15%",
					}, {
						title: "Suspend By",
						value: "suspendBy",
						align: "text-left",
						width: "15%",
					}, {
						title: "Suspend At",
						value: "suspendAt",
						align: "text-left",
						width: "15%",
					}, {
						title: "Action",
						value: "",
						class: "text-center",
						width: "10%",
					}],
				},
				getColorStatus,
				moment,
			}
		},
		created() {
			const _ = this;
			_.get();
		},
    watch: {
      'config.per_page'() {
        this.config.page = 1
        this.get()
      }
    },
		methods: {
			get() {
				this.$table.get(this.config)
			},
			sort(orderby) {
				if(orderby !== "") this.$table.sort(this.config, orderby)
			},
			gotoPage(page) {
				this.$table.gotoPage(this.config, page)
			},

			handleSearch() {
				clearTimeout(this.debounce)
				this.debounce = setTimeout(() => {
					this.config.page = 1
					this.get()
				}, 300)
			},
		},
	}
</script>

<style>

</style>
